import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import { SearchTournament } from '@atlas/components';
import { get, SiteConfigManager, useSearchContext } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Icon } from '@atlas/ui';

import { searchQuerySymbol } from 'common/constants';
import { useSearch } from 'hooks/useSearch';

const { SPORT_PREMATCH } = COMPONENT_TYPES;

const Tournament = memo(({ searchString, tournament }) => {
  const prematchPath = get(
    SiteConfigManager.getConfig('config.pages', []).find(({ type }) => type === SPORT_PREMATCH),
    'path',
  );

  const { categoryName, categoryUrlName, name, sportId, sportName, sportUrlName, urlName } =
    tournament;

  const pathname = `${prematchPath}/${sportUrlName}/${categoryUrlName}/${urlName}`;

  return (
    <Link
      className="search-link"
      to={{
        pathname,
        search: `?${searchQuerySymbol}=${searchString}`,
      }}
    >
      <SearchTournament
        category={categoryName}
        highlight={searchString}
        icon={<Icon name={`sportIcon-${sportId}`} />}
        sport={sportName}
        tournament={name}
      />
    </Link>
  );
});

const SearchTournaments = () => {
  const { tournaments } = useSearchContext();
  const { searchString } = useSearch();

  return tournaments.map(tournament => (
    <Tournament key={tournament.id} searchString={searchString} tournament={tournament} />
  ));
};

export default SearchTournaments;
